import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import TargetNavBar from "../TargetLandingPage/TargetNavBar";
import TargetResultsBanner from "./TargetResultsBanner";
import TargetResultsCarousel from "./TargetResultsCarousel";
import TargetResultsHelp from "./TargetResultsHelp";
import TargetResultsResources from "./TargetResultsResources";
import styles from "./styles.module.scss";
import TargetResultsFAQ from "./TargetResultsFaq";
import { apiGetTargetProducts } from "Root/api/apiQuiz";
import { useHistory } from "react-router";
import Loading from "Components/Loading";
import { Footer } from "Root/checkout/components/Footer";
const TargetResultsPage = () => {
    const [products, setProducts] = useState([]);
    const history = useHistory();
    const getProducts = async () => {
        try {
            const data = await apiGetTargetProducts();
            setProducts(data);
        }
        catch (e) {
            history.push("/quiz-start-target/");
        }
    };
    useEffect(() => {
        getProducts();
    }, []);
    return (_jsxs("div", { className: styles.target, children: [_jsx(TargetNavBar, { noButton: true }), _jsx(TargetResultsBanner, { products: products }), products.length > 0 ? _jsx(TargetResultsCarousel, { products: products }) : _jsx(Loading, {}), _jsx(TargetResultsResources, {}), _jsx(TargetResultsHelp, {}), _jsx(TargetResultsFAQ, {}), _jsx(Footer, { profileFooter: true, userLoggedIn: true })] }));
};
export default TargetResultsPage;
